import { Box, IconButton, IconButtonProps, Tooltip } from '@mui/material';
import { TooltipProps } from '@mui/material/Tooltip/Tooltip';
import { forwardRef } from 'react';

import { ClickHandler, wrapOnClick } from '../../utils/clickEvent';
import { Component, DefiniteComponent, ReturnComponent, SxStyle } from '../../utils/reactTypes';

export const EmptyClickHandler = (): void => {
    return undefined;
};

export interface IAxleIconButtonProps {
    icon: Component;
    tooltip: string;
    onClick: ClickHandler;
    enabled?: boolean;
    tooltipWhenDisabled?: string | undefined;
    placement?: TooltipProps['placement'];
    iconButtonStyle?: SxStyle;
}

export const AxleIconButton = forwardRef(function AxleIconButton(
    {
        icon,
        tooltip,
        onClick,
        enabled = true,
        tooltipWhenDisabled = undefined,
        placement = undefined,
        iconButtonStyle = {},
        ...rest
    }: IAxleIconButtonProps & IconButtonProps,
    ref,
): ReturnComponent {
    if (!enabled && tooltipWhenDisabled !== undefined) {
        tooltip = tooltipWhenDisabled;
    }
    return (
        <Tooltip title={tooltip} placement={placement}>
            {/* The reason for this <Box/> component is otherwise tooltips don’t work with
                 disabled buttons. See: https://stackoverflow.com/q/61115913
                The downside is styling won’t work correctly if the button is used as part
                 of a MUI ButtonGroup, but that’s fine, as we don’t use those. */}
            <Box ref={ref}>
                <IconButton
                    onClick={wrapOnClick(onClick)}
                    disabled={!enabled}
                    sx={iconButtonStyle}
                    aria-label={tooltip}
                    {...rest}
                >
                    {icon}
                </IconButton>
            </Box>
        </Tooltip>
    );
});

export const DisabledAxleIconButton = ({
    tooltip,
    icon,
}: {
    icon: DefiniteComponent;
    tooltip: string;
}): ReturnComponent => {
    return (
        <AxleIconButton
            icon={icon}
            tooltip={tooltip}
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onClick={() => {}}
            enabled={false}
            tooltipWhenDisabled={tooltip}
        />
    );
};
